import React from 'react';
import PageTitle from '../components/PageTitle';
import ServicesIntro from '../components/services/ServicesIntro';
import ServicesList from '../components/ServicesList';
import Marquee from '../components/Marquee';
import WhatMakesUsBest from '../components/services/WhatMakesUsBest';
import GridCTA from '../components/GridCTA';

const ServicesPage = () => {
    return (
        <main id="infocolors-main">
            <div className="stg-container">
                <PageTitle
                    title="Our Services"
                    subtitle="We offer a wide ↔ range of services to help individuals businesses of all sizes achieve 🏆 their creative expectations."
                />
                <ServicesIntro />
                <ServicesList />
                <Marquee />
                <WhatMakesUsBest />
                <GridCTA />
            </div>
        </main>
    );
};

export default ServicesPage;
